import React, {
  useState,
  useImperativeHandle,
  useEffect,
  forwardRef,
  useRef,
} from "react"
import Api from "../../../../_helpers/Api"
import { trans } from "../../../../_providers/Translation"
import servicingHeadImage from "@/assets/img/contractors/icons/servicing-head.svg"

//images
import loader from "../../../../assets/img/loader.svg"
import Success from "../../../modals/messages/Success"
import Error from "../../../modals/messages/Error"
import Dropdown from "@/components/partials/Dropdown"
import moment from "moment"
import Skeleton from "react-loading-skeleton"

function WarrantyServicing(props, ref) {
  const [popup, setPopup] = useState({
    overlay: false,
    modal: false,
    loading: false,
    data: null,
    id: null,
    edit: false,
    loadingData: false,
  })

  const [validations, setValidations] = useState(null)
  const [actions, setActions] = useState([])

  const successModalRef = useRef(null)
  const errorModalRef = useRef(null)
  const inputModelsRef = useRef(null)

  useImperativeHandle(ref, () => ({
    open: (id, type) => {
      handleShow(id, type)
    },
    hide: () => {
      handleHide()
    },
  }))

  useEffect(() => {
    if (popup.edit) {
      loadData()
    }
  }, [popup.edit])

  const loadData = () => {
    if (!popup.id) {
      return
    }

    setPopup((prev) => ({
      ...prev,
      loadingData: true,
    }))

    Api.get(`contractors/appliance-servicing/${popup.id}`)
      .then((res) => {
        setPopup((prev) => ({
          ...prev,
          data: res.data,
        }))
        // Load actions from data if available
        if (
          res.data?.servicing_actions &&
          Array.isArray(res.data.servicing_actions)
        ) {
          setActions(
            res.data.servicing_actions.map((action, idx) => ({
              ...action,
              _key: action.id || Date.now() + idx,
            })),
          )
        }
      })
      .finally(() => {
        setPopup((prev) => ({
          ...prev,
          loadingData: false,
        }))
      })
  }

  const handleShow = (id = null, type = null) => {
    setPopup((prev) => ({
      ...prev,
      id: id,
      edit: id ? new Date() : null,
      type,
    }))

    show()
  }

  const handleHide = (e) => {
    e.preventDefault()

    setPopup((prev) => ({
      ...prev,
      id: null,
      data: null,
      edit: false,
    }))

    setValidations(null)
    setActions([])

    hide().then(() => {
      if (typeof props.onClose === "function") {
        props.onClose()
      }
    })
  }

  const show = async () => {
    return new Promise((resolve, reject) => {
      setPopup((prev) => ({
        ...prev,
        overlay: true,
      }))

      setTimeout(() => {
        setPopup((prev) => ({
          ...prev,
          overlay: true,
          modal: true,
        }))

        return resolve()
      }, 50)
    })
  }

  const hide = async () => {
    return new Promise((resolve, reject) => {
      setPopup((prev) => ({
        ...prev,
        modal: false,
        loading: false,
      }))

      setTimeout(() => {
        setPopup((prev) => ({
          ...prev,
          overlay: false,
          modal: false,
        }))

        return resolve()
      }, 50)
    })
  }

  const handleSave = (e) => {
    e.preventDefault()

    setPopup((prev) => ({
      ...prev,
      loading: true,
    }))

    setValidations(null)

    let url =
      "contractors/appliance-servicing/warranties/" +
      (popup.id && popup.type !== "new" ? "edit" : "add")

    let data = new FormData(e.target)

    if (popup.id) {
      data.append("id", popup.id)
    }

    Api.post(url, data)
      .then((res) => {
        handleHide(e)

        if (typeof props.onSave === "function") {
          props.onSave(res.data)
        }
      })
      .catch((error) => {
        setPopup((prev) => ({
          ...prev,
          loading: false,
        }))

        let _err = error.response

        if (_err && _err.status && _err.status == 422) {
          for (let [input, err] of Object.entries(_err.data.errors)) {
            setValidations((prevState) => {
              return { ...prevState, [input]: true }
            })
          }
        }
      })
  }

  const handleInputChange = (e) => {
    let name = e.target.name
    let val = e.target.value

    setPopup((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        [name]: val,
      },
    }))
  }

  const handleWarrantyChange = (data) => {
    setPopup((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        warranty: data,
      },
    }))
  }

  function handleSwitchChange(e) {
    const { name, checked } = e.target

    setPopup((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        [name]: checked ? 1 : 0,
      },
    }))
  }

  const updateActionField = (index, field, value) => {
    setActions((prev) => {
      const next = prev.slice()
      next[index] = { ...(next[index] || {}), [field]: value }
      return next
    })
  }

  const handleAddAction = () => {
    setActions((prev) => [...prev, { _key: Date.now() }])
  }

  const handleRemoveAction = (index) => {
    setActions((prev) => {
      const next = prev.slice()
      next.splice(index, 1)
      return next
    })
  }

  const handleBrandChange = (data) => {
    setPopup((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        appliancebrand: data,
        appliancemodel: {},
      },
    }))

    if (inputModelsRef.current) {
      inputModelsRef.current.reset()
    }
  }

  const handleModelChange = (data) => {
    setPopup((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        appliancemodel: data,
      },
    }))
  }

  const handleApplianceChange = (data) => {
    setPopup((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        appliancecategory: data,
        appliancebrand: {},
        appliancemodel: {},
      },
    }))

    if (inputModelsRef.current) {
      inputModelsRef.current.reset()
    }
  }

  return (
    <>
      <Success ref={successModalRef} mainMessage={trans("headings.success6")} />

      <Error ref={errorModalRef} mainMessage={trans("headings.error3")} />
      <div className={`${popup.overlay ? "visible" : ""} overlay`}>
        <form
          className={`${popup.modal ? "show" : ""} popup-primary popup-subscription-type medium`}
          onSubmit={handleSave}
        >
          {popup.data?.contractor_id ? (
            <input
              type="hidden"
              name="contractor_id"
              value={popup.data?.contractor_id}
            />
          ) : (
            <></>
          )}

          <div className="head-new" style={{ marginBottom: "10px" }}>
            <img src={servicingHeadImage} alt="icon" />
            <div className="texts">
              <h2>
                {popup.type === "new"
                  ? trans("buttons.newServicing")
                  : trans("headings.servicing")}
              </h2>
              <p>{trans("subheadings.servicing")}</p>
            </div>
            <span className="close" onClick={handleHide}></span>
          </div>

          {popup.loadingData ? (
            <Skeleton height={45} count={5} />
          ) : (
            <>
              <div className="row">
                <div className="col">
                  <label>{trans("labels.name")}</label>
                  <input
                    type="text"
                    name="name"
                    value={popup.data?.name || ""}
                    onChange={handleInputChange}
                    className={
                      validations && validations.name ? "validate" : ""
                    }
                  />
                </div>
                <div className="col">
                  <label>{trans("labels.warranty")}</label>
                  <Dropdown
                    inputName=""
                    inputValue={popup.data?.warranty?.name || ""}
                    inputIdName="warranty_id"
                    inputIdValue={popup.data?.warranty?.id || ""}
                    url="contractors/warranties/all"
                    params={{
                      id: popup.data?.warranty?.id || null,
                      limit: 100,
                    }}
                    inputClassName={
                      validations && validations.warranty_id ? "validate" : ""
                    }
                    onChange={handleWarrantyChange}
                  />
                </div>
                <div
                  className="col"
                  style={{
                    width: "fit-content",
                  }}
                >
                  <label>{trans("labels.servicingDate")}</label>
                  <input
                    type="date"
                    name="date_of_first_servicing"
                    value={
                      popup.data?.date_of_first_servicing ||
                      moment().format("YYYY-MM-DD")
                    }
                    className={
                      validations && validations.date_of_first_servicing
                        ? "validate"
                        : ""
                    }
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col">
                  <label>{trans("labels.category")}</label>
                  <Dropdown
                    inputName=""
                    inputValue={popup.data?.appliancecategory?.name || ""}
                    inputIdName="appliance_category_id"
                    inputIdValue={popup.data?.appliancecategory?.id || ""}
                    url="partners/categories/all"
                    params={{
                      id: popup.data?.appliancecategory?.id || null,
                    }}
                    inputClassName={
                      validations && validations.appliance_category_id
                        ? "validate"
                        : ""
                    }
                    onChange={handleApplianceChange}
                  />
                </div>
                <div className="col">
                  <label>{trans("labels.make")}</label>
                  <Dropdown
                    inputName=""
                    inputValue={popup.data?.appliancebrand?.name || ""}
                    inputIdName="appliance_brand_id"
                    inputIdValue={popup.data?.appliancebrand?.id || ""}
                    url="partners/brands/all"
                    params={{
                      id: popup.data?.appliancebrand?.id || null,
                    }}
                    inputClassName={
                      validations && validations.appliance_brand_id
                        ? "validate"
                        : ""
                    }
                    onChange={handleBrandChange}
                  />
                </div>

                <div className="col">
                  <label>{trans("labels.model")}</label>
                  <input
                    type="text"
                    name="appliance_model"
                    className={
                      validations && validations.appliance_model
                        ? "validate"
                        : ""
                    }
                    value={
                      popup.data && popup.data.appliance_model
                        ? popup.data.appliance_model
                        : ""
                    }
                    onChange={handleInputChange}
                  />
                  {/* <Dropdown
                    ref={inputModelsRef}
                    inputName="appliance_model"
                    inputIdName="appliance_model_id"
                    inputValue={
                      popup.data?.appliancemodel &&
                      popup.data.appliancemodel.name
                        ? popup.data.appliancemodel.name
                        : ""
                    }
                    inputIdValue={
                      popup.data?.appliancemodel && popup.data.appliancemodel.id
                        ? Number(popup.data.appliancemodel.id)
                        : ""
                    }
                    inputClassName={
                      validations?.appliance_model_id ? "validate" : ""
                    }
                    url="appliances/models/all"
                    params={{
                      category_id:
                        popup.data?.appliancecategory &&
                        popup.data.appliancecategory.id
                          ? Number(popup.data.appliancecategory.id)
                          : null,
                      brand_id:
                        popup.data?.appliancebrand &&
                        popup.data.appliancebrand.id
                          ? Number(popup.data.appliancebrand.id)
                          : null,
                    }}
                    requiredParams={["category_id", "brand_id"]}
                    onChange={handleModelChange}
                  /> */}
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <label>{trans("labels.serialNo")}</label>
                  <input
                    value={
                      popup.data && popup.data.serial_no
                        ? popup.data.serial_no
                        : ""
                    }
                    type="text"
                    name="serial_no"
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col">
                  <label>{trans("labels.productCode")}</label>
                  <input
                    type="text"
                    name="product_code"
                    value={
                      popup.data && popup.data.product_code
                        ? popup.data.product_code
                        : ""
                    }
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </>
          )}

          <div className="footer align-right">
            {popup.loading ? (
              <img src={loader} alt="loading" />
            ) : (
              <>
                <button className="button" onClick={handleHide}>
                  {trans("buttons.cancel")}
                </button>
                <button className="button button-primary" type="submit">
                  {trans(popup.type === "new" ? "buttons.newServicing" : "buttons.save")}
                </button>
              </>
            )}
          </div>
        </form>
      </div>
    </>
  )
}

export default forwardRef(WarrantyServicing)
